



































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Mixins, Vue } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { get } from 'lodash';
import { ValidationProvider } from 'vee-validate/dist/types/components/Provider';
//
import { TForm } from '@/plugins/podolib/lib/types';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { Severity } from '@sentry/types';
import { getCountries } from '@/plugins/i18n';
// Components
import PatientPathologyAddOrEdit from '@/components/patients/PatientPathologyAddOrEdit.vue';

type TFields = {
  firstName: {
    value: TPatient['infos']['firstName'];
  };
  lastName: {
    value: TPatient['infos']['lastName'];
  };
  birthDate: {
    value: TPatient['infos']['birthDate'];
    menu: boolean;
    picker: string;
  };
  height: {
    value: TPatient['infos']['height'] | null;
  };
  weight: {
    value: TPatient['infos']['weight'] | null;
  };
  footSize: {
    value: TPatient['infos']['footSize'] | null;
  };
  gender: {
    value: TPatient['infos']['gender'];
  };
  address: {
    streetNumber: {
      value: TPatient['infos']['address']['street_number'];
    };
    route: {
      value: TPatient['infos']['address']['route'];
    };
    city: {
      value: TPatient['infos']['address']['city'];
    };
    country: {
      value: TPatient['infos']['address']['country'];
    };
    zipCode: {
      value: TPatient['infos']['address']['pos_code'];
    };
  };
  contact: {
    email: {
      value: TPatient['infos']['contact']['email'];
    };
    phone: {
      value: TPatient['infos']['contact']['phone'];
    };
  };
  background?: {
    value: string | null;
  };
  presentingComplaint?: {
    value: string | null;
  };
};
type TMode = 'add' | 'edit';
type TFootSizeSelector = {
  value: number;
  uk: number;
  us: number;
};
type TCountry = {
  pending: boolean;
  items: string[];
};

@Component({
  components: { PatientPathologyAddOrEdit },
})
export default class PatientAddOrEdit extends Mixins(MixinDialog) {
  $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
    form: InstanceType<typeof Vue> & { reset: () => void };
    picker: any;
  };

  @Prop({ required: true }) private mode!: TMode;
  @Prop({ default: null }) private patient?: TEntity<TPatient> | null;
  @Prop({ default: false }) private disabled!: boolean;

  healthyPatient: boolean = false;

  form: TForm<TFields> = {
    fields: {
      firstName: {
        value: '',
      },
      lastName: {
        value: '',
      },
      birthDate: {
        value: '',
        menu: false,
        picker: '',
      },
      height: {
        value: null,
      },
      weight: {
        value: null,
      },
      footSize: {
        value: null,
      },
      gender: {
        value: 0,
      },
      address: {
        streetNumber: {
          value: '',
        },
        route: {
          value: '',
        },
        city: {
          value: '',
        },
        country: {
          value: '',
        },
        zipCode: {
          value: '',
        },
      },
      contact: {
        email: {
          value: '',
        },
        phone: {
          value: '',
        },
      },
      background: {
        value: null,
      },
      presentingComplaint: {
        value: null,
      },
    },
    pending: false,
    error: null,
    success: false,
  };
  selectedPathology: any = null;

  get footSizes(): TFootSizeSelector[] {
    return [
      {
        value: 35,
        uk: 2.5,
        us: 4,
      },
      {
        value: 36,
        uk: 3.5,
        us: 5,
      },
      {
        value: 37,
        uk: 4,
        us: 5.5,
      },
      {
        value: 38,
        uk: 5,
        us: 6.5,
      },
      {
        value: 39,
        uk: 5.5,
        us: this.form.fields.gender.value === 1 ? 7.5 : 6,
      },
      {
        value: 40,
        uk: 6.5,
        us: this.form.fields.gender.value === 1 ? 8 : 7,
      },
      {
        value: 41,
        uk: 7.5,
        us: this.form.fields.gender.value === 1 ? 9 : 8,
      },
      {
        value: 42,
        uk: 8,
        us: this.form.fields.gender.value === 1 ? 9.5 : 8.5,
      },
      {
        value: 43,
        uk: 9,
        us: this.form.fields.gender.value === 1 ? 10.5 : 9.5,
      },
      {
        value: 44,
        uk: 9.5,
        us: 10,
      },
      {
        value: 45,
        uk: 10.5,
        us: 11,
      },
      {
        value: 46,
        uk: 11,
        us: 11.5,
      },
      {
        value: 47,
        uk: 12,
        us: 12.5,
      },
      {
        value: 48,
        uk: 13,
        us: 13.5,
      },
      {
        value: 49,
        uk: 14,
        us: 14.5,
      },
      {
        value: 50,
        uk: 50,
        us: 50.5,
      },
    ];
  }
  get countries() {
    return getCountries({ excludeNoDial: true });
  }

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      if (this.mode === 'edit' && this.patient) {
        this.form.fields.firstName.value = this.patient.infos.firstName;
        this.form.fields.lastName.value = this.patient.infos.lastName;

        this.form.fields.birthDate.value = this.$moment(this.patient.infos.birthDate).format(
          this.$pdc.helper!.dateFormatRelatedToSelectedLanguage,
        );
        this.form.fields.birthDate.picker = this.$moment(this.patient.infos.birthDate).format('YYYY-MM-DD');

        this.form.fields.height.value = this.patient.infos.height;
        this.form.fields.weight.value = this.patient.infos.weight;
        this.form.fields.footSize.value = this.patient.infos.footSize;
        this.form.fields.gender.value = this.patient.infos.gender;
        this.form.fields.address.streetNumber.value = get(this.patient.infos, 'address.street_number', '');
        this.form.fields.address.route.value = get(this.patient.infos, 'address.route', '');
        this.form.fields.address.city.value = get(this.patient.infos, 'address.city', '');
        this.form.fields.address.country.value = get(this.patient.infos, 'address.country', '');
        this.form.fields.address.zipCode.value = get(this.patient.infos, 'address.pos_code', '');
        this.form.fields.contact.email.value = get(this.patient.infos, 'contact.email', '');
        this.form.fields.contact.phone.value = get(this.patient.infos, 'contact.phone', '');
      } else {
        this.form.fields.firstName.value = '';
        this.form.fields.lastName.value = '';
        this.form.fields.birthDate.value = '';
        this.form.fields.height.value = null;
        this.form.fields.weight.value = null;
        this.form.fields.footSize.value = null;
        this.form.fields.gender.value = 1;
        this.form.fields.address.streetNumber.value = '';
        this.form.fields.address.route.value = '';
        this.form.fields.address.city.value = '';
        this.form.fields.address.country.value = '';
        this.form.fields.address.zipCode.value = '';
        this.form.fields.contact.email.value = '';
        this.form.fields.contact.phone.value = '';
      }

      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }
  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }
  @Watch('form.fields.birthDate.menu')
  onFormFieldsBirthDateMenuChanged(state: boolean) {
    if (state)
      this.$nextTick(() => {
        this.$refs.picker.activePicker = 'YEAR';
      });
  }

  // Date picker
  datePickerToField() {
    const t = this.form.fields.birthDate;
    const m = this.$moment(t.picker, 'YYYY-MM-DD');
    if (m.isValid()) {
      const d = m.format(this.$pdc.helper!.dateFormatRelatedToSelectedLanguage);

      if (d !== t.value) {
        t.value = d;
      }

      t.menu = false;
    }
  }
  fieldToDatePicker() {
    const t = this.form.fields.birthDate;
    const m = this.$moment(t.value, this.$pdc.helper!.dateFormatRelatedToSelectedLanguage);
    if (m.isValid()) {
      const d = m.format('YYYY-MM-DD');

      if (d !== t.picker) {
        t.picker = d;
      }
    }
  }

  // Form actions
  async save() {
    if (this.mode === 'add') {
      await this.add();
    } else {
      await this.edit();
    }
  }
  async add() {
    // Avoid duplication of the process
    if (this.form.pending) return;

    let data =
      this.mode === 'add'
        ? {
            infos: {
              firstName: this.cleanValue(this.form.fields.firstName.value),
              lastName: this.cleanValue(this.form.fields.lastName.value),
              birthDate: this.cleanValue(
                this.$moment(
                  this.form.fields.birthDate.value,
                  this.$pdc.helper!.dateFormatRelatedToSelectedLanguage,
                ).format('YYYY-MM-DD'),
              ),
              height: this.cleanValue(this.form.fields.height.value),
              weight: this.cleanValue(this.form.fields.weight.value),
              footSize: this.cleanValue(this.form.fields.footSize.value),
              gender: this.cleanValue(this.form.fields.gender.value),
              address: {
                street_number: this.cleanValue(this.form.fields.address.streetNumber.value),
                route: this.cleanValue(this.form.fields.address.route.value),
                city: this.cleanValue(this.form.fields.address.city.value),
                country: this.cleanValue(this.form.fields.address.country.value),
                pos_code: this.cleanValue(this.form.fields.address.zipCode.value),
              },
              contact: {
                email: this.cleanValue(this.form.fields.contact.email.value),
                phone: this.cleanValue(this.form.fields.contact.phone.value),
              },
              pathologies:
                this.selectedPathology && !this.isCustomPathology(this.selectedPathology)
                  ? [this.selectedPathology]
                  : [],
              customPathologies:
                this.selectedPathology && this.isCustomPathology(this.selectedPathology)
                  ? [this.selectedPathology]
                  : [],
              background: this.form.fields.background?.value ? this.cleanValue(this.form.fields.background.value) : '',
              consultationReason: this.form.fields.presentingComplaint?.value
                ? this.cleanValue(this.form.fields.presentingComplaint.value)
                : '',
            },
          }
        : {
            infos: {
              firstName: this.cleanValue(this.form.fields.firstName.value),
              lastName: this.cleanValue(this.form.fields.lastName.value),
              birthDate: this.cleanValue(
                this.$moment(
                  this.form.fields.birthDate.value,
                  this.$pdc.helper!.dateFormatRelatedToSelectedLanguage,
                ).format('YYYY-MM-DD'),
              ),
              height: this.cleanValue(this.form.fields.height.value),
              weight: this.cleanValue(this.form.fields.weight.value),
              footSize: this.cleanValue(this.form.fields.footSize.value),
              gender: this.cleanValue(this.form.fields.gender.value),
              address: {
                street_number: this.cleanValue(this.form.fields.address.streetNumber.value),
                route: this.cleanValue(this.form.fields.address.route.value),
                city: this.cleanValue(this.form.fields.address.city.value),
                country: this.cleanValue(this.form.fields.address.country.value),
                pos_code: this.cleanValue(this.form.fields.address.zipCode.value),
              },
              contact: {
                email: this.cleanValue(this.form.fields.contact.email.value),
                phone: this.cleanValue(this.form.fields.contact.phone.value),
              },
            },
          };

    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;

      // Try to create the patient ...
      const patient: TEntity<TPatient> = await this.$pdc.repository!.emit('create', 'patients', data);
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Patient Created', data);
      // Set 'success' flag
      this.form.success = true;
      // Send global event
      this.$pdc.bus!.emit('patient:added', patient._id);
      // Redirect...
      await this.$router.push(`/patient/${patient._id}`);
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Patient Created', e, data);
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
  async edit() {
    // TODO patch necessary field only
    // Avoid duplication of the process
    if (this.form.pending) return;

    const data = {
      infos: {
        firstName: this.cleanValue(this.form.fields.firstName.value),
        lastName: this.cleanValue(this.form.fields.lastName.value),
        birthDate: this.cleanValue(
          this.$moment(this.form.fields.birthDate.value, this.$pdc.helper!.dateFormatRelatedToSelectedLanguage).format(
            'YYYY-MM-DD',
          ),
        ),
        height: this.cleanValue(this.form.fields.height.value),
        weight: this.cleanValue(this.form.fields.weight.value),
        footSize: this.cleanValue(this.form.fields.footSize.value),
        gender: this.cleanValue(this.form.fields.gender.value),
        address: {
          street_number: this.cleanValue(this.form.fields.address.streetNumber.value),
          route: this.cleanValue(this.form.fields.address.route.value),
          city: this.cleanValue(this.form.fields.address.city.value),
          country: this.cleanValue(this.form.fields.address.country.value),
          pos_code: this.cleanValue(this.form.fields.address.zipCode.value),
        },
        contact: {
          email: this.cleanValue(this.form.fields.contact.email.value),
          phone: this.cleanValue(this.form.fields.contact.phone.value),
        },
        pathologies: this.patient?.infos?.pathologies,
        consultationReason: this.patient?.infos?.consultationReason,
        background: this.patient?.infos?.background,
      },
    };

    const previous = this.patient?.infos;

    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;

      // Try to patch the patient ...
      const patchedPatient: TEntity<TPatient> = await this.$pdc.repository!.emit(
        'patch',
        'patients',
        {
          _id: this.patient!._id,
        },
        data,
      );

      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Patient Edited', data, previous);
      // Set 'success' flag
      this.form.success = true;
      // Send global event
      this.$pdc.bus!.emit('patient:edited', this.patient!._id);

      // Patch user
      this.$store.commit('pdc/entities/patients/PATCH_ONE', patchedPatient);

      this.close();
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Patient Edited', e, data, previous);
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }

  clear() {
    this.$refs.form.reset();
    this.selectedPathology = null;
    requestAnimationFrame(() => {
      (this.$refs.observer as Vue & { reset: () => void }).reset();
    });
  }
  open() {
    this.dialog = true;
  }
  close() {
    this.clear();
    this.dialog = false;
  }
  closeDialog() {
    if (!this.form.success) this.clear();
    this.dialog = false;
  }
  cleanValue(value: any, defaultValue?: any): any {
    if (typeof value === 'undefined') {
      return defaultValue || null;
    } else {
      return value;
    }
  }

  // Open pathology dialog
  addPatientPathology() {
    this.$pdc.bus!.emit('patient-creation:pathology:add');
    // (this.$refs['add-edit-pathology-dialog'] as any).openAdd()
  }
  editPatientPathology() {
    this.$pdc.bus!.emit('patient-creation:pathology:edit', this.selectedPathology);
    // (this.$refs['add-edit-pathology-dialog'] as any).openEdit(this.selectedPathology)
  }
  removePathology() {
    this.selectedPathology = null;
  }

  async findPathology(pathology: any) {
    const result = await this.$pdc
      .repository!.getRessource({
        ressource: 'pathologies',
        identifier: pathology.reference,
        params: {},
      })
      .catch((e: any) => {
        console.log(e);
      });
    this.selectedPathology = pathology.sinceDate
      ? {
          reference: result,
          sinceDate: pathology.sinceDate,
        }
      : {
          reference: result,
        };
  }
  setSelectedPathology(pathology: any) {
    this.healthyPatient = false;
    if (pathology.name) {
      this.selectedPathology = pathology;
    } else {
      this.findPathology(pathology);
    }
  }
  isCustomPathology(pathology: any) {
    return !!pathology?.name;
  }

  async created() {
    if (this.$route.params.addPatient && this.automatedOpen) {
      this.open();
    }
  }
  mounted() {
    if (this.listenBus) {
      this.$pdc.bus!.on(`patient:${this.mode}`, this.open);
    }
  }
  beforeDestroy() {
    if (this.listenBus) {
      this.$pdc.bus!.off(`patient:${this.mode}`, this.open);
    }
  }
}
